import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appPercentageDirective]',
})
export class PercentageDirective implements OnInit {
  @Input('appPercentageDirective') ref;
  @Output() valueChanged = new EventEmitter<any>();
  private el: any;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.el.value = parseFloat((this.el.value * 100).toFixed(5));
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value): void {
    this.valueChanged.emit(parseFloat((value / 100).toFixed(5)));
  }

}
